import { Stack } from '@mui/material';
import { Partner } from '@provision/entity-types';
import { EditorEvents } from '@provision/rich-text-editor';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { RichTextField } from 'src/components/Forms/RichTextField/rich-text-field';
import { NullableDeepPartial } from 'src/graphql/types';

interface SystemInfoTabProps {
  partner: NullableDeepPartial<Pick<Partner, 'partnerId' | 'partnerOnesheet'>>;
  onFieldChange: (field: string, value: string) => void;
  readonly: boolean;
}

export const SystemInfoTab = ({ partner, onFieldChange, readonly }: SystemInfoTabProps) => {
  const partnerDetails = partner?.partnerOnesheet?.[0];

  const fields = useMemo(() => {
    if (isNullish(partner?.partnerId)) {
      return [];
    }

    return [
      {
        label: 'System Info',
        editorOptions: {
          editable: !readonly,
          onUpdate: ({ editor }: EditorEvents['update']) => {
            onFieldChange('asTransferForBusinessHoursOnly', editor.getHTML());
          },
          content: partnerDetails?.asTransferForBusinessHoursOnly ?? '',
        },
        dependencies: [partner.partnerId],
      },
    ];
  }, [
    readonly,
    partner.partnerId,
    partnerDetails?.asTransferForBusinessHoursOnly,
    onFieldChange,
  ]);

  return (
    <Stack spacing={2} sx={{ paddingTop: 2 }}>
      {fields.map((field) => (
        <RichTextField
          key={field.label}
          label={field.label}
          editorOptions={field.editorOptions}
          dependencies={field.dependencies}
        />
      ))}
    </Stack>
  );
};
